import {
  claimWebDocumentTitle,
  releaseWebDocumentTitle,
} from '@/core/utils/webDocumentTitleOverride';
import { useIsFocused } from '@react-navigation/native';
import { usePathname } from 'expo-router';
import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';

/**
 * Sets the browser tab from the focused screen.
 * A screen that stays mounted underneath the next route releases the title
 * when it blurs, so the path title (FAQ, and the rest) can take over.
 * Native has no document title.
 */
export function useWebDocumentTitle(
  title: string | undefined,
  description?: string | undefined,
): void {
  const isFocused = useIsFocused();
  const pathname = usePathname();
  const pathnameRef = useRef(pathname);
  if (isFocused) {
    pathnameRef.current = pathname;
  }

  useEffect(() => {
    if (Platform.OS !== 'web' || !isFocused) {
      return;
    }
    const pageTitle = title?.trim() ?? '';
    if (pageTitle.length === 0) {
      return;
    }
    const claimId = claimWebDocumentTitle({
      title: pageTitle,
      description,
      pathname: pathnameRef.current,
    });
    return () => {
      releaseWebDocumentTitle(claimId);
    };
  }, [description, isFocused, title]);
}
